import { render, staticRenderFns } from "./modal-order-remark.vue?vue&type=template&id=f4e9a708&scoped=true&"
import script from "./modal-order-remark.vue?vue&type=script&lang=js&"
export * from "./modal-order-remark.vue?vue&type=script&lang=js&"
import style0 from "./modal-order-remark.vue?vue&type=style&index=0&id=f4e9a708&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4e9a708",
  null
  
)

export default component.exports